import { Checkbox, Divider, Modal, TextField, Typography, Alert, Box, Button, CircularProgress, Grid } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { CSVLink } from "react-csv";
import { toast } from "react-toastify";
import { formatDate } from "../../common/utils";
import {
  getReportFormat,
  getTodaysReport,
  updateQuantity,
  updateRemark,
} from "../../services/transactions";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import Papa from "papaparse";
import moment from "moment";
import LoadingScreen from "../../utils/LoadingScreen";
import { MyContext } from "../ContextApi";
const ExportReports = () => {
  const { getDecryptedSessionItem } = useContext(MyContext);
  const [clientCode1, setClientCode] = useState("");
  const [quantities, setQuantities] = useState([]);
  const [mkParekhData, setMkParekhData] = useState();
  const [selectedStockist, setSelectedStockist] = useState(null);
  const [selectedStockistName, setSelectedStockistName] = useState("");
  const [selectedStockistCode, setSelectedStockistCode] = useState("");
  const stokistName = selectedStockistName?.replace(/\./g, "");
  const stokistCode = selectedStockistCode?.replace(/\./g, "");
  const [selectedCategoryCheckboxes, setSelectedCategoryCheckboxes] =
    useState();
  const [selectedRemarkCheckboxes, setSelectedRemarkCheckboxes] = useState();
  const [headers, setHeaders] = useState([]);
  const [manKindDate, setManKindDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [stockists, setStockists] = useState([]);
  const [records, setRecords] = useState([]);
  const [fromDate, setFromDate] = useState(
    moment().startOf("day").format("YYYY-MM-DD HH:mm:ss")
  );
  const [toDate, setToDate] = useState(
    moment().endOf("day").format("YYYY-MM-DD HH:mm:ss")
  );
  const [openAlkemSendModal, setOpenAlkemSendModal] = useState(false);
  const [alkemPayload, setAlkemPayload] = useState({
    plantCode: getDecryptedSessionItem("installationId"),
    fgrn_doc: "",
    partyCode: stokistCode,
    plantName: getDecryptedSessionItem("userName"),
    fgrn_date: "",
    partyName: stokistName,
    partyPlace: "",
    remarks: "",
    transportName: "",
    grn_date: "",
    party_ref: "",
    party_ref_date: "",
    lr_num: "",
    lr_date: "",
    entryDate: "",
    rateFlag: "1",
    refInv: "",
    taxFlag: "P",
    tagId: "",
    no_of_cases: 5,
    dcFile: "",
    instiFlag: "Y",
    godownExp: "N",
    nplHq: "",
    vendorRefNo: "",
    fromDate: "",
    endDate: "",
    remark: "",
  });
  const fileName =
    getDecryptedSessionItem("reportType") === "mankind" ||
      getDecryptedSessionItem("reportType") === "mkparekh"
      ? `${stokistCode}_${manKindDate}`
      : `${stokistName}_${stokistCode}`;
  const loadReportType = async () => {
    const response = await getReportFormat();
    if (response["status"] === "success") {
      setHeaders(JSON.parse(response["data"]["columns"]));
    } else {
      toast.error(
        "Error while getting the report format.. please contact ORBO"
      );
    }
  };
  useEffect(() => {
    loadReportType();
  }, []);
  useEffect(() => {
    if (!selectedStockistCode || !selectedStockistName) return;
    setAlkemPayload(prev => ({
      ...prev,
      partyCode: selectedStockistCode.trim(), // or apply your cleaning if really needed
      partyName: selectedStockistName.trim(),
    }));
  }, [selectedStockistCode, selectedStockistName]);
  const loadTodaysReport = async () => {
    if (new Date(toDate) - new Date(fromDate) <= 0) {
      toast.error("To Date must be greater than From Date");
      return;
    }
    setLoading(true);
    const response = await getTodaysReport(fromDate, toDate);
    if (response["status"] === "success") {
      setLoading(false);
      const responsedata = response["data"];
      const data = responsedata.filter(item => item.platform !== null)
        .map(item => {
          const sanitize = (val) => (val === "nan" || val === null || val === undefined ? "" : val);
          return {
            ...item,
            mfg: sanitize(item.mfg),
            clientCode: sanitize(item.clientCode),
            clientName: sanitize(item.clientName),
            remark: sanitize(item.remark),
            region: sanitize(item.region),
            lrDate: sanitize(item.lrDate),
            recDate: sanitize(item.recDate),
          };
        });
      const tmpStockists = [];
      const sortedItems = [...data]
        .sort((a, b) => {
          if (a.platform < b.platform) return -1;
          if (a.platform > b.platform) return 1;
          return 0;
        })
        .sort((a, b) => {
          return (a.sku || "").localeCompare(b.sku || "");
        });
      for (const entry of sortedItems) {
        const isValidDate = (val) =>
          val !== null &&
          val !== undefined &&
          val !== "nan" &&
          val !== "Invalid date" &&
          val !== "" &&
          val !== "-NA-";

        if (isValidDate(entry["expiry"]) && isValidDate(entry["mfg"])) {
          const dateFormats = [
            "MM-YYYY",
            "M-YYYY",
            "MM/YYYY",
            "M/YYYY",
            "YYYY-MM-DD",
            "DD/MM/YYYY",
            "MM-YY",
            "MM/YY",
          ];
          const expMoment = moment(entry["expiry"], dateFormats);
          const mfgMoment = moment(entry["mfg"], dateFormats);

          if (
            expMoment.isValid() &&
            mfgMoment.isValid() &&
            expMoment.isBefore(mfgMoment)
          ) {
            const tempExpiry = entry["expiry"];
            entry["expiry"] = entry["mfg"];
            entry["mfg"] = tempExpiry;
          }
        }

        const index = tmpStockists.findIndex(
          (item) => item.clientCode === entry.clientCode
        );
        let newEntry = { ...entry };
        newEntry["formattedExpiryDate"] = moment(entry["expiry"], "MM-YYYY")
          .endOf("month")
          .format("DD/MM/YYYY");
        newEntry["formattedMFGDate"] =
          entry["mfg"] === "nan" ||
            entry["mfg"] === "Invalid date" ||
            entry["mfg"] === "" ||
            entry["mfg"] === "-NA-"
            ? ""
            : moment(entry["mfg"], "MM-YYYY")
              .startOf("month")
              .format("DD/MM/YYYY");
        newEntry["platform"] =
          newEntry["platform"] === "web" ? "Manual" : newEntry["platform"];
        newEntry["created_date_time"] = moment(entry["created_date_time"])
          .local()
          .format("YYYY-MM-DD HH:mm:ss");
        setManKindDate(
          moment(entry["created_date_time"]).local().format("YYYY-MM-DD")
        );
        newEntry.remark = entry.remark;
        newEntry.user = getDecryptedSessionItem("clientId");
        newEntry.category =
          getDecryptedSessionItem("reportType") === "troikaa"
            ? entry.category === "expiry" || entry.category === "over-expiry"
              ? "NS1"
              : entry.category === "damage"
                ? "NS2"
                : entry.category[0].toUpperCase() + entry.category.slice(1)
            : getDecryptedSessionItem("reportType") === "alembic"
              ? entry.category === "expiry" || entry.category === "over-expiry"
                ? "01"
                : entry.category === "damage"
                  ? "02"
                  : entry.category === "near expiry"
                    ? "42"
                    : entry.category === "spoiled"
                      ? "03"
                      : entry?.category?.[0]?.toUpperCase() + entry?.category?.slice(1)
              : entry?.category?.[0]?.toUpperCase() + entry?.category?.slice(1);
        if (getDecryptedSessionItem("reportType") === "ajanta") {
          newEntry.category =
            entry.category === "damage" ? "ZSD143S" : "ZSD143N";
        }
        if (getDecryptedSessionItem("reportType") === "abbott") {
          newEntry.type = "ZR02";
          newEntry.formattedExpiryDate = newEntry?.formattedExpiryDate
            ?.split("/")
            .reverse()
            .join("");
          newEntry.units = "EA";
          newEntry.installationId = getDecryptedSessionItem("installationId");
          const abbottCategoryMapping = {
            expiry: "3",
            ["over-expiry"]: "3",
            breakage: "1",
            spoiled: "2",
            leakage: "4",
            loose: "37",
            productRecall: "5",
            qualityIssue: "6",
          };
          newEntry.org = "1220";
          newEntry.Channel = "12";
          newEntry["LR DATE"] = moment(entry?.lrDate, "DD-MM-YYYY").format(
            "YYYYMMDD"
          );
          newEntry.orderReason = "C04";
          newEntry.category = abbottCategoryMapping[entry?.category] || null;
        }
        const currentMonth = new Date().getMonth() + 1;
        const currentYear = new Date().getFullYear();
        const expiryDateMonth = Number(entry.expiry.split("-")[0]);
        const expiryDateYear = Number(entry.expiry.split("-")[1]);
        if (getDecryptedSessionItem("reportType") === "elan") {
          const nearExpiryMonth = currentMonth + 3;
          if (currentYear > expiryDateYear) {
            newEntry.category = "EXPIRED";
          }
          if (currentYear < expiryDateYear) {
            newEntry.category = "DAMAGED";
            if (nearExpiryMonth > 12) {
              if (nearExpiryMonth % 12 >= expiryDateMonth) {
                newEntry.category = "NEAR EXPIRY";
              } else {
                newEntry.category = "DAMAGED";
              }
            }
          }
          if (currentYear === expiryDateYear) {
            if (currentMonth >= expiryDateMonth) {
              newEntry.category = "EXPIRED";
            } else if (
              expiryDateMonth > currentMonth &&
              expiryDateMonth <= nearExpiryMonth
            ) {
              newEntry.category = "NEAR EXPIRY";
            } else {
              newEntry.category = "DAMAGED";
            }
          }
          if (expiryDateYear >= currentYear + 2) {
            newEntry.category = "DAMAGED";
          }
        }
        if (getDecryptedSessionItem("reportType") === "sun") {
          const nearExpiryMonth = currentMonth + 3;
          if (currentYear > expiryDateYear) {
            newEntry.category = "SXP";
          }
          if (currentYear < expiryDateYear) {
            newEntry.category = "SDM";
            if (nearExpiryMonth > 12) {
              if (nearExpiryMonth % 12 > expiryDateMonth) {
                newEntry.category = "SXP";
              } else {
                newEntry.category = "SDM";
              }
            }
          }
          if (currentYear == expiryDateYear) {
            if (currentMonth == expiryDateMonth) {
              newEntry.category = "SNX";
            } else if (
              expiryDateMonth > currentMonth &&
              expiryDateMonth <= nearExpiryMonth
            ) {
              newEntry.category = "SNX";
            } else {
              newEntry.category = "SDM";
            }
            if (currentMonth > expiryDateMonth) {
              newEntry.category = "SXP";
            }
          }
        }
        if (getDecryptedSessionItem("reportType") === "intas") {
          const nearExpiryMonth = currentMonth + 2;
          if (currentYear == expiryDateYear) {
            if (currentMonth == expiryDateMonth) {
              entry.category = "expiry";
            } else if (
              expiryDateMonth > currentMonth &&
              expiryDateMonth <= nearExpiryMonth
            ) {
              entry.category = "near expiry";
            }
          }
          newEntry.category =
            entry.category === "near expiry"
              ? "Near expiry"
              : entry.category === "over-expiry" || entry.category === "expiry"
                ? "Expiry"
                : "Damage";
        }
        if (getDecryptedSessionItem("reportType") === "alkem") {
          const expiryDateValue = expiryDateYear * 12 + expiryDateMonth;
          const currentDateValue = currentYear * 12 + currentMonth;
          const nearExpiryStartValue = currentDateValue + 1;
          const nearExpiryEndValue = currentDateValue + 2;
          if (expiryDateValue <= currentDateValue) {
            newEntry.category = "expiry";
          } else if (
            expiryDateValue >= nearExpiryStartValue &&
            expiryDateValue <= nearExpiryEndValue
          ) {
            newEntry.category = "near expiry";
          } else {
            newEntry.category = "saleable";
          }
        }
        if (getDecryptedSessionItem("reportType") === "bluecross") {
          const assumedExpiryMonth = currentMonth + 5;
          if (currentYear > expiryDateYear) {
            newEntry.category = "ZXPY";
          } else if (currentYear === expiryDateYear) {
            if (
              (currentMonth < expiryDateMonth &&
                expiryDateMonth <= assumedExpiryMonth) ||
              currentMonth >= expiryDateMonth
            ) {
              newEntry.category = "ZXPY";
            } else {
              newEntry.category = "ZBB";
            }
          } else if (currentYear < expiryDateYear) {
            if (assumedExpiryMonth > 12) {
              if (assumedExpiryMonth % 12 > expiryDateMonth) {
                newEntry.category = "ZXPY";
              } else {
                newEntry.category = "ZBB";
              }
            }
            newEntry.category = "ZBB";
          }
        }
        if (getDecryptedSessionItem("reportType") === "macleods") {
          if (newEntry.category === "Damage") {
            newEntry.category = "Damage";
          }
          if (
            newEntry.category === "Expiry" ||
            newEntry.category === "Over-expiry" ||
            newEntry.category === "Damage"
          ) {
            newEntry.orderType = "ZR02";
          } else {
            newEntry.orderType = "ZR01";
          }
        }
        if (
          getDecryptedSessionItem("reportType") === "mankind" ||
          getDecryptedSessionItem("reportType") === "mkparekh"
        ) {
          const nearExpiryMonth = currentMonth + 2;
          if (currentYear > expiryDateYear) {
            entry.category = "expiry";
          }
          if (currentYear < expiryDateYear) {
            entry.category = "damage";
            if (nearExpiryMonth > 12) {
              if (nearExpiryMonth % 12 > expiryDateMonth) {
                entry.category = "expiry";
              } else {
                entry.category = "damage";
              }
            }
          }
          if (currentYear === expiryDateYear) {
            if (nearExpiryMonth >= expiryDateMonth) {
              entry.category = "expiry";
            } else {
              entry.category = "damage";
            }
          }
          newEntry.category = entry.category === "expiry" ? "E" : "B";
        }
        if (getDecryptedSessionItem("reportType") === "zydus") {
          newEntry.optional3 = entry.barcode2;
          // Use category from database - no recalculation
          // This ensures consistency between TodaysReport and ExportReports
          newEntry.category = entry.category === "expiry" ? "Expiry" :
            entry.category === "near expiry" ? "Near expiry" :
              entry.category === "saleable" ? "Saleable" :
                entry.category === "damage" ? "Damage" :
                  entry.category === "over-expiry" ? "Over expiry" : entry.category;
        }
        if (getDecryptedSessionItem("reportType") === "cadila") {
          newEntry.optional3 = entry.barcode2;
        }
        if (index === -1) {
          tmpStockists.push({
            clientCode: entry.clientCode,
            clientName: entry.clientName,
            records: [newEntry],
          });
        } else {
          const isSameProductItem = (item, newEntry) => {
            const barcode2Match =
              item.barcode2 === newEntry.barcode2 ||
              !item.barcode2 ||
              !newEntry.barcode2;

            return (
              barcode2Match &&
              item.sku === newEntry.sku &&
              item.batch === newEntry.batch &&
              item.expiry === newEntry.expiry &&
              item.itemCode === newEntry.itemCode &&
              parseFloat(item.mrp) === parseFloat(newEntry.mrp) &&
              item.mfg === newEntry.mfg &&
              item.obatch === newEntry.obatch &&
              item.remark === newEntry.remark &&
              item.category === newEntry.category
            );
          };

          const productIndex = tmpStockists[index].records.findIndex((item) =>
            isSameProductItem(item, newEntry)
          );
          if (productIndex === -1) {
            tmpStockists[index].records.push(newEntry);
          } else {
            tmpStockists[index].records[productIndex].quantity = (
              parseFloat(tmpStockists[index].records[productIndex].quantity) +
              parseFloat(entry.quantity)
            ).toString();
          }
        }
      }
      if (getDecryptedSessionItem("reportType") === "troikaa") {
        console.log(tmpStockists, "tmpStockists");
        for (const stockist of tmpStockists) {
          stockist.records = stockist.records.map((obj) => {
            obj.optional1 = (
              parseInt(obj.quantity) /
              (isNaN(parseInt(obj.barcode2)) || obj.barcode2 === null || obj.barcode2 === ""
                ? 1
                : parseInt(obj.barcode2))).toFixed(2);
            return obj;
          });
          console.log(stockist.records, "stockist.records");
        }
      }
      if (getDecryptedSessionItem("reportType") === "sun") {
        const plant = getDecryptedSessionItem("installationId").includes('_')
          ? getDecryptedSessionItem("installationId").split('_')[1]
          : getDecryptedSessionItem("installationId");
        for (const stockist of tmpStockists) {
          let counter = 0;
          stockist.records = stockist.records.map((obj) => {
            counter++;
            if (counter == 321) {
              counter = 1;
            }
            obj["CustomerReference"] =
              "1899" +
              "_" +
              obj.clientCode +
              "_" +
              moment(obj.created_date_time)
                .local()
                .format("DD-MM-YY")
                .replace("-", "")
                .split("-")[0];
            obj["Counter"] = counter;
            obj["SalesDocumentType"] = "ZRDO";
            obj["OrderReason"] = "SXP";
            obj["SalesOrganization"] = "115S";
            obj["DistributionChannel"] = 10;
            obj["Division"] =
              obj["optional2"] == "30" || obj["optional2"] == 30 ? "CH" : 0;
            obj["CustRefInvoiceNo"] = "";
            obj["CustomerReferenceInvoiceDate"] = "";
            obj["LRNumber"] = obj["remark"];
            obj["AnnexureArticleNumber"] = 17;
            obj["Material"] = obj["itemCode"];
            obj["ProductName"] = obj["sku"];
            obj["Plant"] = plant;
            obj["Storagelocation"] =
              obj["category"] === "SXP"
                ? "4005"
                : obj["category"] === "SDM"
                  ? "4001"
                  : "4006";
            obj["ReasonforReturn"] = obj["category"];
            obj["recDate"] = obj["recDate"].replaceAll("/", ".");
            obj["lrDate"] = obj["lrDate"].replaceAll("/", ".");
            return obj;
          });
        }
      }
      setStockists(tmpStockists);
      if (tmpStockists.length > 0) {
        setSelectedStockist(tmpStockists[0]?.clientCode);
        setRecords(tmpStockists[0].records);
      }
    } else {
      toast.error(response["error"]);
    }
  };
  const onSelectStockist = (clientCode) => {
    setClientCode(clientCode);
    const index = stockists.findIndex((item) => item.clientCode === clientCode);
    setRecords(stockists[index].records);
  };
  useEffect(() => {
    setSelectedCategoryCheckboxes(getCategoryCSVLinks());
    setSelectedRemarkCheckboxes(getRemarkCSVLinks());
    setSelectedStockistCode(records[0]?.clientCode);
    setSelectedStockistName(records[0]?.clientName);
  }, [records]);
  const groupRecordsByCategory = () => {
    const groupedRecords = {};
    records.forEach((record) => {
      const category = record?.category || "Uncategorized";
      if (!groupedRecords[category]) {
        groupedRecords[category] = [];
      }
      groupedRecords[category].push(record);
    });
    return groupedRecords;
  };
  const getCategoryCSVLinks = () => {
    const groupedRecords = groupRecordsByCategory();
    const categoryCSVLinks = {};
    Object.keys(groupedRecords).forEach((category) => {
      if (!categoryCSVLinks[category]) {
        categoryCSVLinks[category] = false;
      }
      categoryCSVLinks[category] = false;
    });
    return categoryCSVLinks;
  };
  const handleCategoryCheckboxChange = (category) => {
    setSelectedCategoryCheckboxes((prevState) => {
      return {
        ...prevState,
        [category]: !prevState?.[category],
      };
    });
  };
  const handleDownloadSelectedCategories = (
    selectedCategoryCheckboxes,
    selectedRemarkCheckboxes
  ) => {
    const groupedRecords = groupRecordsByCategory();
    const zip = new JSZip();
    const formatRecords = (record, headers, length) => {
      const formattedRecord = {};
      if (getDecryptedSessionItem("reportType") === "wallace") {
        const itemValue = 10;
        headers.forEach((header, ind) => {
          const keys = header.key.split(".");
          let value = record;
          for (const key of keys) {
            value = value ? value[key] : "";
          }
          if (keys.includes("formattedExpiryDate")) {
            value = formatDate(value);
          }
          let lrNumber;
          let poNumber;
          if (record.remark.indexOf(",") !== -1) {
            lrNumber = record.remark.substring(0, record.remark.indexOf(","));
            poNumber = record.remark.substring(record.remark.indexOf(",") + 1);
          } else {
            lrNumber = record.remark;
            poNumber = "";
          }
          let expiryMonth = record?.expiry?.substring(
            0,
            record?.expiry?.indexOf("-")
          );
          let expiryYear = record?.expiry?.substring(
            record?.expiry?.indexOf("-") + 1
          );
          const newExpiryMonth = parseInt(expiryMonth);
          const newExpiryYear = parseInt(expiryYear);
          let storageLocation;
          let headerReason;
          let itemReason;
          const d = new Date();
          let month = d.getMonth();
          let year = d.getFullYear();
          if (year > newExpiryYear) {
            storageLocation = "FG05";
            headerReason = "Z02";
            itemReason = 5;
          } else if (year === newExpiryYear) {
            if (newExpiryMonth <= month + 2) {
              storageLocation = "FG05";
              headerReason = "Z02";
              itemReason = 5;
            } else if (
              newExpiryYear === year &&
              (month === 11 || month === 12)
            ) {
              storageLocation = "FG05";
              headerReason = "Z02";
              itemReason = 5;
            } else {
              storageLocation = "FG06";
              headerReason = "Z01";
              itemReason = 3;
            }
          } else {
            storageLocation = "FG06";
            headerReason = "Z01";
            itemReason = 3;
          }
          let lrDate = record.lrDate;
          let parts = lrDate.split("/");
          let formatedLrDate = `${parts[0]}.${parts[1]}.${parts[2]}`;
          let physicalRecieptDate = record.recDate;
          let parts1 = physicalRecieptDate.split("/");
          let formatedPhysicalRecieptDate = `${parts1[0]}.${parts1[1]}.${parts1[2]}`;
          let originalDateString = record.created_date_time;
          const date = new Date(originalDateString);
          const formattedDate = `${date
            .getDate()
            .toString()
            .padStart(2, "0")}.${(date.getMonth() + 1)
              .toString()
              .padStart(2, "0")}.${date.getFullYear()} ${date
                .getHours()
                .toString()
                .padStart(2, "0")}:${date
                  .getMinutes()
                  .toString()
                  .padStart(2, "0")}:${date
                    .getSeconds()
                    .toString()
                    .padStart(2, "0")}`;
          switch (header.label) {
            case "Sales Org":
              value = "WPPL";
              break;
            case "Distribution channal":
              value = 10;
              break;
            case "Division":
              value = 0;
              break;
            case "Order Type":
              value = "ZNSR";
              break;
            case "PO Number":
              value = poNumber;
              break;
            case "Item":
              value = itemValue * length + 10;
              break;
            case "Item Category":
              value = "ZNSR";
              break;
            case "Plant":
              value = "MH02";
              break;
            case "Storage Location":
              value = storageLocation;
              break;
            case "Header Reason":
              value = headerReason;
              break;
            case "Item Reason":
              value = itemReason;
              break;
            case "LR Number":
              value = lrNumber;
              break;
            case "LR Date":
              value = formatedLrDate;
              break;
            case "PO Date":
              value = formatedLrDate;
              break;
            case "Physical Reciept Date":
              value = formatedPhysicalRecieptDate;
              break;
            case "Scan Date":
              value = formattedDate;
              break;
            default:
              break;
          }
          formattedRecord[header.label] = value;
        });
      } else if (getDecryptedSessionItem("reportType") === "elan") {
        headers.forEach((header) => {
          const keys = header.key.split(".");
          let value = record;
          for (const key of keys) {
            value = value ? value[key] : "";
          }
          if (keys.includes("formattedExpiryDate")) {
            value = formatDate(value);
          }
          let rate = record.barcode2;
          switch (header.label) {
            case "RATE":
              value = rate;
              break;
            default:
              break;
          }
          formattedRecord[header.label] = value;
        });
      } else {
        headers.forEach((header) => {
          const keys = header.key.split(".");
          let value = record;
          for (const key of keys) {
            value = value ? value[key] : "";
          }
          if (keys.includes("formattedExpiryDate")) {
            value = formatDate(value);
          }
          formattedRecord[header.label] = value;
        });
      }
      return formattedRecord;
    };
    const processRecord = (record, remark, csvData) => {
      const formattedRecord = formatRecords(record, headers, csvData.length);
      if (getDecryptedSessionItem("reportType") === "macleods") {
        const lrDateParts = formattedRecord["LR Date"] ? formattedRecord["LR Date"].split("/") : [];
        if (lrDateParts.length === 3) {
          formattedRecord["LR Date"] = `${lrDateParts[0]}.${lrDateParts[1]}.${lrDateParts[2]}`;
        }
        if (formattedRecord["Order Reason"] && formattedRecord["Order Reason"].toLowerCase() === "damage") {
          formattedRecord["Order Reason"] = "Z04";
        } else {
          formattedRecord["Order Reason"] = "";
        }
      }
      csvData.push(formattedRecord);
    };
    const generateCSVContent = (data, category) => {
      const csvHeaders = headers.map((header) => header.label);
      const csvContent = Papa.unparse({
        fields: csvHeaders,
        data: data,
      });
      zip.file(`${fileName}(${category}).csv`, csvContent);
    };
    Object.keys(selectedCategoryCheckboxes).forEach((category) => {
      if (selectedCategoryCheckboxes[category]) {
        const csvData = [];
        const selectedRemarks = Object.keys(selectedRemarkCheckboxes);
        for (const record of groupedRecords[category]) {
          if (Object.values(selectedRemarkCheckboxes).some(Boolean)) {
            selectedRemarks.forEach((remark) => {
              if (
                record.remark === remark &&
                selectedRemarkCheckboxes[remark]
              ) {
                processRecord(record, category, csvData);
              }
            });
          } else {
            processRecord(record, category, csvData);
          }
        }
        generateCSVContent(csvData, category);
      }
    });
    zip.generateAsync({ type: "blob" }).then((content) => {
      saveAs(content, "SelectedCategories.zip");
    });
  };
  const handleDownloadSelectedRemark = (
    selectedCategoryCheckboxes,
    selectedRemarkCheckboxes
  ) => {
    const groupedRecords = groupRecordsByRemark();
    const zip = new JSZip();
    const formatRecords = (record, headers, length) => {
      const formattedRecord = {};
      if (getDecryptedSessionItem("reportType") === "wallace") {
        let itemValue = 10;
        headers.forEach((header) => {
          const keys = header.key.split(".");
          let value = record;
          for (const key of keys) {
            value = value ? value[key] : "";
          }
          if (keys.includes("formattedExpiryDate")) {
            value = formatDate(value);
          }
          let lrNumber;
          let poNumber;
          if (record.remark.indexOf(",") !== -1) {
            lrNumber = record.remark.substring(0, record.remark.indexOf(","));
            poNumber = record.remark.substring(record.remark.indexOf(",") + 1);
          } else {
            lrNumber = record.remark;
            poNumber = "";
          }
          let expiryMonth = record?.expiry?.substring(
            0,
            record?.expiry?.indexOf("-")
          );
          let expiryYear = record?.expiry?.substring(
            record?.expiry?.indexOf("-") + 1
          );
          const newExpiryMonth = parseInt(expiryMonth);
          const newExpiryYear = parseInt(expiryYear);
          let storageLocation;
          let headerReason;
          let itemReason;
          const d = new Date();
          let month = d.getMonth();
          let year = d.getFullYear();
          if (year > newExpiryYear) {
            storageLocation = "FG05";
            headerReason = "Z02";
            itemReason = 5;
          } else if (year === newExpiryYear) {
            if (newExpiryMonth <= month + 2) {
              storageLocation = "FG05";
              headerReason = "Z02";
              itemReason = 5;
            } else if (
              newExpiryYear === year &&
              (month === 11 || month === 12)
            ) {
              storageLocation = "FG05";
              headerReason = "Z02";
              itemReason = 5;
            } else {
              storageLocation = "FG06";
              headerReason = "Z01";
              itemReason = 3;
            }
          } else {
            storageLocation = "FG06";
            headerReason = "Z01";
            itemReason = 3;
          }
          let lrDate = record.lrDate;
          let parts = lrDate.split("/");
          let formatedLrDate = `${parts[0]}.${parts[1]}.${parts[2]}`;
          let physicalRecieptDate = record.recDate;
          let parts1 = physicalRecieptDate.split("/");
          let formatedPhysicalRecieptDate = `${parts1[0]}.${parts1[1]}.${parts1[2]}`;
          let originalDateString = record.created_date_time;
          const date = new Date(originalDateString);
          const formattedDate = `${date
            .getDate()
            .toString()
            .padStart(2, "0")}.${(date.getMonth() + 1)
              .toString()
              .padStart(2, "0")}.${date.getFullYear()} ${date
                .getHours()
                .toString()
                .padStart(2, "0")}:${date
                  .getMinutes()
                  .toString()
                  .padStart(2, "0")}:${date
                    .getSeconds()
                    .toString()
                    .padStart(2, "0")}`;
          switch (header.label) {
            case "Sales Org":
              value = "WPPL";
              break;
            case "Distribution channal":
              value = 10;
              break;
            case "Division":
              value = 0;
              break;
            case "Order Type":
              value = "ZNSR";
              break;
            case "PO Number":
              value = poNumber;
              break;
            case "Item":
              value = itemValue * length + 10;
              break;
            case "Item Category":
              value = "ZNSR";
              break;
            case "Plant":
              value = "MH02";
              break;
            case "Storage Location":
              value = storageLocation;
              break;
            case "Header Reason":
              value = headerReason;
              break;
            case "Item Reason":
              value = itemReason;
              break;
            case "LR Number":
              value = lrNumber;
              break;
            case "LR Date":
              value = formatedLrDate;
              break;
            case "PO Date":
              value = formatedLrDate;
              break;
            case "Physical Reciept Date":
              value = formatedPhysicalRecieptDate;
              break;
            case "Scan Date":
              value = formattedDate;
              break;
            default:
              break;
          }
          formattedRecord[header.label] = value;
        });
      } else if (getDecryptedSessionItem("reportType") === "elan") {
        headers.forEach((header, ind) => {
          const keys = header.key.split(".");
          let value = record;
          for (const key of keys) {
            value = value ? value[key] : "";
          }
          if (keys.includes("formattedExpiryDate")) {
            value = formatDate(value);
          }
          let rate = record.barcode2;
          switch (header.label) {
            case "RATE":
              value = rate;
              break;
            default:
              break;
          }
          formattedRecord[header.label] = value;
        });
      } else {
        headers.forEach((header) => {
          const keys = header.key.split(".");
          let value = record;
          for (const key of keys) {
            value = value ? value[key] : "";
          }
          if (keys.includes("formattedExpiryDate")) {
            value = formatDate(value);
          }
          formattedRecord[header.label] = value;
        });
      }
      return formattedRecord;
    };
    const processRecord = (record, remark, csvData) => {
      const formattedRecord = formatRecords(record, headers, csvData.length);
      if (getDecryptedSessionItem("reportType") === "macleods") {
        const lrDateParts = formattedRecord["LR Date"] ? formattedRecord["LR Date"].split("/") : [];
        if (lrDateParts.length === 3) {
          formattedRecord["LR Date"] = `${lrDateParts[0]}.${lrDateParts[1]}.${lrDateParts[2]}`;
        }
        if (formattedRecord["Order Reason"] && formattedRecord["Order Reason"].toLowerCase() === "damage") {
          formattedRecord["Order Reason"] = "Z04";
        } else {
          formattedRecord["Order Reason"] = "";
        }
      }
      csvData.push(formattedRecord);
    };
    const generateCSVContent = (data, remark) => {
      const csvHeaders = headers.map((header) => header.label);
      const csvContent = Papa.unparse({
        fields: csvHeaders,
        data: data,
      });
      zip.file(`${fileName}(${remark}).csv`, csvContent);
    };
    Object.keys(selectedRemarkCheckboxes).forEach((remark) => {
      if (selectedRemarkCheckboxes[remark]) {
        const csvData = [];
        const records = groupedRecords[remark];
        for (const record of records) {
          if (Object.values(selectedCategoryCheckboxes).some(Boolean)) {
            Object.keys(selectedCategoryCheckboxes).forEach((category) => {
              if (
                selectedCategoryCheckboxes[category] &&
                record.remark === category
              ) {
                processRecord(record, remark, csvData);
              }
            });
          } else {
            processRecord(record, remark, csvData);
          }
        }
        generateCSVContent(csvData, remark);
      }
    });
    zip.generateAsync({ type: "blob" }).then((content) => {
      saveAs(content, "SelectedRemarks.zip");
    });
  };
  const groupRecordsByRemark = () => {
    const groupedRecords = {};
    if (getDecryptedSessionItem("reportType") === "mkparekh") {
      records.forEach((record) => {
        const remark = record?.remark || "Uncategorized";
        setClientCode(record?.clientCode);
        if (!groupedRecords[remark]) {
          groupedRecords[remark] = [];
        }
        groupedRecords[remark].push(record);
      });
    } else {
      records.forEach((record) => {
        const remark = record?.remark || "Uncategorized";
        if (!groupedRecords[remark]) {
          groupedRecords[remark] = [];
        }
        groupedRecords[remark].push(record);
      });
    }
    return groupedRecords;
  };
  const getRemarkCSVLinks = () => {
    const groupedRecords = groupRecordsByRemark();
    const remarkCSVLinks = {};
    Object.keys(groupedRecords).forEach((remark) => {
      remarkCSVLinks[remark] = false;
    });
    return remarkCSVLinks;
  };
  const handleRemarkCheckboxChange = (remark) => {
    setSelectedRemarkCheckboxes((prevState) => ({
      ...prevState,
      [remark]: !prevState?.[remark],
    }));
  };
  const obatchGroups = records.reduce((groups, record) => {
    const obatch = record.obatch;
    if (!groups[obatch]) {
      groups[obatch] = [];
    }
    groups[obatch].push(record);
    return groups;
  }, {});
  const updatedObatchPlatforms = {};
  for (const obatch in obatchGroups) {
    const obatchRecords = obatchGroups[obatch];
    const platforms = obatchRecords.map((record) => record.platform);
    if (platforms.every((platform) => platform === "Manual")) {
      updatedObatchPlatforms[obatch] = "Manual";
    } else if (
      platforms.some((platform) => platform.includes("Auto - Auto")) ||
      platforms.some((platform) => platform.includes("Auto - Manual")) ||
      platforms.some((platform) => platform.includes("Auto Confirm - Auto")) ||
      platforms.some((platform) =>
        platform.includes("Auto Confirm - Manual")
      ) ||
      platforms.some((platform) => platform.includes("Manual"))
    ) {
      updatedObatchPlatforms[obatch] = "Auto - Auto";
    } else if (
      platforms.some((platform) => platform.includes("Auto Confirm - Auto")) ||
      platforms.some((platform) =>
        platform.includes("Auto Confirm - Manual")
      ) ||
      platforms.some((platform) => platform.includes("Manual"))
    ) {
      updatedObatchPlatforms[obatch] = "Auto Confirm - Auto";
    } else if (
      platforms.some((platform) => platform.includes("Auto - Manual")) ||
      platforms.some((platform) => platform.includes("Manual"))
    ) {
      updatedObatchPlatforms[obatch] = "Auto - Auto";
    } else {
      updatedObatchPlatforms[obatch] = "Auto - Auto";
    }
  }
  let updatedRecordsData;
  if (getDecryptedSessionItem("reportType") === "wallace") {
    const itemValue = 10;
    updatedRecordsData = records.map((record, ind) => {
      const obatch = record.obatch;
      const newPlatform = updatedObatchPlatforms[obatch];
      let lrNumber;
      let poNumber;
      if (record.remark.indexOf(",") !== -1) {
        lrNumber = record.remark.substring(0, record.remark.indexOf(","));
        poNumber = record.remark.substring(record.remark.indexOf(",") + 1);
      } else {
        lrNumber = record.remark;
        poNumber = "";
      }
      let expiryMonth = record?.expiry?.substring(
        0,
        record?.expiry?.indexOf("-")
      );
      let expiryYear = record?.expiry?.substring(
        record?.expiry?.indexOf("-") + 1
      );
      const newExpiryMonth = parseInt(expiryMonth);
      const newExpiryYear = parseInt(expiryYear);
      let storageLocation;
      let headerReason;
      let itemReason;
      const d = new Date();
      let month = d.getMonth();
      let year = d.getFullYear();
      if (year > newExpiryYear) {
        storageLocation = "FG05";
        headerReason = "Z02";
        itemReason = 5;
      } else if (year === newExpiryYear) {
        if (newExpiryMonth <= month + 2) {
          storageLocation = "FG05";
          headerReason = "Z02";
          itemReason = 5;
        } else if (newExpiryYear === year && (month === 11 || month === 12)) {
          storageLocation = "FG05";
          headerReason = "Z02";
          itemReason = 5;
        } else {
          storageLocation = "FG06";
          headerReason = "Z01";
          itemReason = 3;
        }
      } else {
        storageLocation = "FG06";
        headerReason = "Z01";
        itemReason = 3;
      }
      let lrDate = record.lrDate;
      let parts = lrDate.split("/");
      let formatedLrDate = `${parts[0]}.${parts[1]}.${parts[2]}`;
      let physicalRecieptDate = record.recDate;
      let parts1 = physicalRecieptDate.split("/");
      let formatedPhysicalRecieptDate = `${parts1[0]}.${parts1[1]}.${parts1[2]}`;
      let originalDateString = record.created_date_time;
      const date = new Date(originalDateString);
      const formattedDate = `${date.getDate().toString().padStart(2, "0")}.${(
        date.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}.${date.getFullYear()} ${date
          .getHours()
          .toString()
          .padStart(2, "0")}:${date
            .getMinutes()
            .toString()
            .padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}`;
      return {
        ...record,
        platform: newPlatform,
        "Sales Org": "WPPL",
        "Distribution channal": 10,
        Division: 0,
        "Order Type": "ZNSR",
        Item: itemValue * ind + 10,
        "Item Category": "ZNSR",
        Plant: "MH02",
        "Storage Location": storageLocation,
        "Header Reason": headerReason,
        "Item Reason": itemReason,
        "LR Number": lrNumber,
        "PO Number": poNumber,
        "LR Date": formatedLrDate,
        "PO Date": formatedLrDate,
        "Physical Reciept Date": formatedPhysicalRecieptDate,
        "Scan Date": formattedDate,
      };
    });
  } else if (getDecryptedSessionItem("reportType") === "elan") {
    updatedRecordsData = records.map((record, ind) => {
      let rate = record.barcode2;
      return {
        ...record,
        RATE: rate,
      };
    });
  } else if (getDecryptedSessionItem("reportType") === "macleods") {
    updatedRecordsData = records.map((record, ind) => {
      let formatlrDate = record.lrDate;
      if (formatlrDate) {
        const dateParts = formatlrDate.split("/");
        if (dateParts.length === 3) {
          const day = dateParts[0];
          const month = dateParts[1];
          const year = dateParts[2];
          formatlrDate = `${day}.${month}.${year}`;
        } else {
          formatlrDate = "";
        }
      }
      let reportCategory = "";
      if (record.category === "Damage") {
        reportCategory = "Z04";
      } else {
        reportCategory = "";
      }
      return {
        ...record,
        category: reportCategory,
        lrDate: formatlrDate,
      };
    });
  } else if (getDecryptedSessionItem("reportType") === "fdc") {
    updatedRecordsData = records.map((record) => {
      const recDate = moment(record.recDate, "DD/MM/YYYY");
      if (!recDate.isValid()) {
        console.error(`Invalid recDate: ${record.recDate}`);
        return { ...record, category: "INVALID_DATE" };
      }
      const expiryDate = moment(record.expiry, "MM/YYYY").endOf("month");
      const currentMonth = recDate.month();
      const currentYear = recDate.year();
      const recMonth = expiryDate.month();
      const recYear = expiryDate.year();
      let categoryValue = "";
      if (
        recYear < currentYear ||
        (recYear === currentYear && recMonth <= currentMonth)
      ) {
        categoryValue = "FG02";
      } else {
        const daysDifference = expiryDate.diff(recDate, "days");
        if (daysDifference <= 180 && daysDifference > 0) {
          categoryValue = "NEXP";
        } else if (daysDifference > 180) {
          categoryValue = "DAMG";
        }
      }
      return {
        ...record,
        category: categoryValue,
      };
    });
  } else {
    updatedRecordsData = records.map((record) => {
      const obatch = record.obatch;
      const newPlatform = updatedObatchPlatforms[obatch];
      return { ...record, platform: newPlatform };
    });
  }
  useEffect(() => {
    if (getDecryptedSessionItem("reportType") === "mkparekh") {
      const updatedRecords = records.map((record) => {
        const obatch = record.obatch;
        const newPlatform = updatedObatchPlatforms[obatch];
        return { ...record, platform: newPlatform };
      });
      setMkParekhData(updatedRecords);
    }
  }, [records]);
  useEffect(() => {
    setQuantities(records.map((item) => item.quantity));
  }, [records]);
  const handleQuantityChange = (index, value, item) => {
    const newQuantities = [...quantities];
    newQuantities[index] = value;
    setQuantities(newQuantities);
  };
  const handleQuantitySubmit = async (id, index, clientCode) => {
    const response = await updateQuantity({
      quantity: quantities[index],
      id,
    });
    if (response["status"] === "success") {
      toast.success("successfully updated quantities");
      let qty;
      updatedRecordsData = records.map((record) => {
        if (record?.id === id) {
          qty = quantities[index];
          return { ...record, quantity: qty };
        }
        return record;
      });
      setMkParekhData(updatedRecordsData);
      setRecords(updatedRecordsData);
      setStockists((prevStockists) =>
        prevStockists.map((ele) => {
          if (ele.clientCode === clientCode) {
            return { ...ele, records: updatedRecordsData };
          }
          return ele;
        })
      );
    } else {
      toast.error(response["error"]);
    }
  };
  const [editRemark, setEditRemark] = useState({ category: "", value: "" });
  const handleEditChange = (e) => {
    setEditRemark({ ...editRemark, value: e.target.value });
  };
  const handleEditSubmit = async (category) => {
    const response = await updateRemark(
      category,
      editRemark.value,
      clientCode1
    );
    if (response["status"] === "success") {
      toast.success("successfully updated remark");
      let newRemark;
      updatedRecordsData = records.map((record) => {
        if (record?.remark === category) {
          newRemark = editRemark.value;
          return { ...record, remark: newRemark };
        }
        return record;
      });
      setMkParekhData(updatedRecordsData);
      setRecords(updatedRecordsData);
      setStockists((prevStockists) =>
        prevStockists.map((ele) => {
          if (ele.clientCode === clientCode1) {
            return { ...ele, records: updatedRecordsData };
          }
          return ele;
        })
      );
    } else {
      toast.error(response["error"]);
    }
    setEditRemark({ category: "", value: "" });
  };

  const handleDownloadNovasFile = () => {
    const novasHeaders = [
      "Item Code", "Product Name", "Quantities", "Batch Number", "Expiry Date", "Name", "Division No.", "Division Name"
    ];

    const anyCategorySelected = Object.values(selectedCategoryCheckboxes || {}).some(Boolean);
    const anyRemarkSelected = Object.values(selectedRemarkCheckboxes || {}).some(Boolean);

    let filteredRecords = updatedRecordsData;
    if (anyCategorySelected || anyRemarkSelected) {
      filteredRecords = updatedRecordsData.filter(record => {
        let categoryMatch = true;
        let remarkMatch = true;
        
        if (anyCategorySelected) {
          const cat = record.category || "Uncategorized";
          categoryMatch = !!selectedCategoryCheckboxes[cat];
        }
        
        if (anyRemarkSelected) {
          const rem = record.remark || "Uncategorized";
          remarkMatch = !!selectedRemarkCheckboxes[rem];
        }
        
        return categoryMatch && remarkMatch;
      });
    }

    const csvData = filteredRecords.map(record => {
      const itemCode = record.itemCode || "";
      const productName = record.sku || "";
      const quantities = record.quantity || "";
      const batchNumber = record.obatch ? record.obatch : (record.batch || "");
      const expiryDate = record.formattedExpiryDate || (record.expiry ? moment(record.expiry, "MM-YYYY").endOf("month").format("DD/MM/YYYY") : "");
      const name = record.category || "";
      const divisionNo = record.optional1 || "";
      const divisionName = record.optional2; 

      return {
        "Item Code": itemCode,
        "Product Name": productName,
        "Quantities": quantities,
        "Batch Number": batchNumber,
        "Expiry Date": expiryDate,
        "Name": name,
        "Division No.": divisionNo,
        "Division Name": divisionName
      };
    });

    const csvContent = Papa.unparse({
      fields: novasHeaders,
      data: csvData
    });
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
    saveAs(blob, `${fileName}_Novas.csv`);
  };

  const handleDownload = () => {
    let fileExtension = "txt";
    let csvHeaders = "";

    if (getDecryptedSessionItem("reportType") === "sun") {
      csvHeaders =
        [
          "Cust. Reference",
          "Counter",
          "Sales Doc. Type",
          "Order Reason",
          "Sales Org.",
          "Distr. Channel",
          "Division",
          "Sold-to Party",
          "Ship-to Party",
          "Bill-to Party",
          "Cust. Ref. Date",
          "Cust Ref Invoice No.",
          "Cust Ref Inv Date",
          "LR Date",
          "LR Number",
          "ActMaterialRecDate",
          "Annexure Article No.",
          "Material",
          "Order Quantity",
          "Plant",
          "Batch",
          "Stor. Loc.",
          "Return/Change Reason",
          "ProductName",
        ].join(",") + "\n";
      fileExtension = "csv";
    }

    const formatData = (data) => {
      let formattedData;
      if (getDecryptedSessionItem("reportType") === "sun") {
        formattedData = data
          .map((record) => {
            return `${record["CustomerReference"]},${record["Counter"]},${record["SalesDocumentType"]},${record["OrderReason"]},${record["SalesOrganization"]},${record["DistributionChannel"]},${record["Division"]},${record.clientCode},${record.clientCode},${record.clientCode},${record["recDate"]},${record["CustRefInvoiceNo"]},${record["CustomerReferenceInvoiceDate"]},${record["lrDate"]},${record["LRNumber"]},${record["recDate"]},${record["AnnexureArticleNumber"]},${record["Material"]},${record.quantity},${record["Plant"]},${record.batch},${record["Storagelocation"]},${record["category"]},${record["ProductName"]}`;
          })
          .join("\n");
      } else {
        formattedData = data
          .map((record) => {
            return `${record.itemCode}\t${record.batch}\t${record.quantity}\t${record.category}`;
          })
          .join("\n");
      }
      if (fileExtension === "csv") {
        formattedData = csvHeaders + formattedData;
      }
      return formattedData;
    };

    if (getDecryptedSessionItem("reportType") === "alembic") {
      const selectedRemarks = Object.keys(selectedRemarkCheckboxes || {}).filter(remark => selectedRemarkCheckboxes[remark]);

      if (selectedRemarks.length > 0) {
        const zip = new JSZip();
        selectedRemarks.forEach((remark) => {
          const filteredData = updatedRecordsData.filter(record => (record?.remark || "Uncategorized") === remark);
          if (filteredData.length > 0) {
            const formatted = formatData(filteredData);
            zip.file(`${fileName}(${remark}).${fileExtension}`, formatted);
          }
        });

        zip.generateAsync({ type: "blob" }).then((content) => {
          saveAs(content, `${fileName}_Remarks.zip`);
        });
        return;
      }
    }

    const formattedData = formatData(updatedRecordsData);
    const blob = new Blob([formattedData], {
      type: "text/csv;charset=utf-8",
    });
    saveAs(blob, `${fileName}.${fileExtension}`);
  };
  const handleDownloadSelectedCategoriesText = (
    selectedCategoryCheckboxes,
    selectedRemarkCheckboxes
  ) => {
    const groupedRecords = groupRecordsByCategory();
    Object.keys(selectedCategoryCheckboxes).forEach((category) => {
      if (selectedCategoryCheckboxes[category]) {
        const csvData = [];
        const selectedRemarks = Object.keys(selectedRemarkCheckboxes);
        const formatRecords = (record, headers, length) => {
          const formattedRecord = {};
          headers.forEach((header) => {
            const keys = header.key.split(".");
            let value = record;
            for (const key of keys) {
              value = value ? value[key] : "";
            }
            if (keys.includes("formattedExpiryDate")) {
              value = formatDate(value);
            }
            formattedRecord[header.label] = value;
          });
          return formattedRecord;
        };
        const processRecord = (record, category, csvData) => {
          const formattedRecord = formatRecords(
            record,
            headers,
            csvData.length
          );
          csvData.push(formattedRecord);
        };
        for (const record of groupedRecords[category]) {
          if (Object.values(selectedRemarkCheckboxes).some(Boolean)) {
            selectedRemarks.forEach((remark) => {
              if (
                record.remark === remark &&
                selectedRemarkCheckboxes[remark]
              ) {
                processRecord(record, category, csvData);
              }
            });
          } else {
            processRecord(record, category, csvData);
          }
        }
        let formattedData;
        let fileExtension = "txt";
        let csvHeaders = "";
        if (getDecryptedSessionItem("reportType") === "sun") {
          csvHeaders =
            [
              "Cust. Reference",
              "Counter",
              "Sales Doc. Type",
              "Order Reason",
              "Sales Org.",
              "Distr. Channel",
              "Division",
              "Sold-to Party",
              "Ship-to Party",
              "Bill-to Party",
              "Cust. Ref. Date",
              "Cust Ref Invoice No.",
              "Cust Ref Inv Date",
              "LR Date",
              "LR Number",
              "ActMaterialRecDate",
              "Annexure Article No.",
              "Material",
              "Order Quantity",
              "Plant",
              "Batch",
              "Stor. Loc.",
              "Return/Change Reason",
              "ProductName",
            ].join(",") + "\n";
          formattedData = updatedRecordsData
            .map((record) => {
              return `${record["CustomerReference"]},${record["Counter"]},${record["SalesDocumentType"]},${record["OrderReason"]},${record["SalesOrganization"]},${record["DistributionChannel"]},${record["Division"]},${record.clientCode},${record.clientCode},${record.clientCode},${record["recDate"]},${record["CustRefInvoiceNo"]},${record["CustomerReferenceInvoiceDate"]},${record["lrDate"]},${record["LRNumber"]},${record["recDate"]},${record["AnnexureArticleNumber"]},${record["Material"]},${record.quantity},${record["Plant"]},${record.batch},${record["Storagelocation"]},${record["category"]},${record["ProductName"]}`;
            })
            .join("\n");
          fileExtension = "csv";
        } else {
          formattedData = updatedRecordsData
            .map((record) => {
              return `${record.itemCode}\t${record.batch}\t${record.quantity}\t${record.category}`;
            })
            .join("\n");
        }
        if (fileExtension === "csv") {
          formattedData = csvHeaders + formattedData;
        }
        const blob = new Blob([formattedData], {
          type: "text/csv;charset=utf-8",
        });
        saveAs(blob, `${fileName}.${fileExtension}`);
      }
    });
  };
  const handleDownloadSelectedRemarkText = (
    selectedCategoryCheckboxes,
    selectedRemarkCheckboxes
  ) => {
    const groupedRecords = groupRecordsByRemark();
    const formatRecords = (record, headers, length) => {
      const formattedRecord = {};
      headers.forEach((header) => {
        const keys = header.key.split(".");
        let value = record;
        for (const key of keys) {
          value = value ? value[key] : "";
        }
        if (keys.includes("formattedExpiryDate")) {
          value = formatDate(value);
        }
        formattedRecord[header.label] = value;
      });
      return formattedRecord;
    };
    const processRecord = (record, remark, csvData) => {
      const formattedRecord = formatRecords(record, headers, csvData.length);
      csvData.push(formattedRecord);
    };
    Object.keys(selectedRemarkCheckboxes).forEach((remark) => {
      if (selectedRemarkCheckboxes[remark]) {
        const csvData = [];
        const records = groupedRecords[remark];
        for (const record of records) {
          if (Object.values(selectedCategoryCheckboxes).some(Boolean)) {
            Object.keys(selectedCategoryCheckboxes).forEach((category) => {
              if (
                selectedCategoryCheckboxes[category] &&
                record.remark === category
              ) {
                processRecord(record, remark, csvData);
              }
            });
          } else {
            processRecord(record, remark, csvData);
          }
        }
        let formattedData;
        let fileExtension = "txt";
        let csvHeaders = "";
        if (getDecryptedSessionItem("reportType") === "sun") {
          csvHeaders =
            [
              "Cust. Reference",
              "Counter",
              "Sales Doc. Type",
              "Order Reason",
              "Sales Org.",
              "Distr. Channel",
              "Division",
              "Sold-to Party",
              "Ship-to Party",
              "Bill-to Party",
              "Cust. Ref. Date",
              "Cust Ref Invoice No.",
              "Cust Ref Inv Date",
              "LR Date",
              "LR Number",
              "ActMaterialRecDate",
              "Annexure Article No.",
              "Material",
              "Order Quantity",
              "Plant",
              "Batch",
              "Stor. Loc.",
              "Return/Change Reason",
              "ProductName",
            ].join(",") + "\n";
          formattedData = updatedRecordsData
            .map((record) => {
              return `${record["CustomerReference"]},${record["Counter"]},${record["SalesDocumentType"]},${record["OrderReason"]},${record["SalesOrganization"]},${record["DistributionChannel"]},${record["Division"]},${record.clientCode},${record.clientCode},${record.clientCode},${record["recDate"]},${record["CustRefInvoiceNo"]},${record["CustomerReferenceInvoiceDate"]},${record["lrDate"]},${record["LRNumber"]},${record["recDate"]},${record["AnnexureArticleNumber"]},${record["Material"]},${record.quantity},${record["Plant"]},${record.batch},${record["Storagelocation"]},${record["category"]},${record["ProductName"]}`;
            })
            .join("\n");
          fileExtension = "csv";
        } else {
          formattedData = updatedRecordsData
            .map((record) => {
              return `${record.itemCode}\t${record.batch}\t${record.quantity}\t${record.category}`;
            })
            .join("\n");
        }
        if (fileExtension === "csv") {
          formattedData = csvHeaders + formattedData;
        }
        const blob = new Blob([formattedData], {
          type: "text/csv;charset=utf-8",
        });
        saveAs(blob, `${fileName}.${fileExtension}`);
      }
    });
  };
  const getFilteredRecordsForAlkem = () => {
    const anyRemarkSelected = Object.values(selectedRemarkCheckboxes || {}).some(Boolean);
    if (!anyRemarkSelected) {
      return records;
    }
    return records.filter(record => {
      const remark = record?.remark || "Uncategorized";
      return selectedRemarkCheckboxes?.[remark] === true;
    });
  };
  const handleSendToAlkem = async () => {
    if (records.length === 0) {
      toast.error("No products available to send");
      return;
    }
    const filtered = getFilteredRecordsForAlkem();
    if (filtered.length === 0) {
      toast.warn("No records match the selected remarks");
      return;
    }
    const lastRecord = filtered[filtered.length - 1] || records[records.length - 1];
    console.log("lastRecord", lastRecord)
    let createdISO = "";
    let lrISO = "";
    let partyplaceResult = lastRecord?.region || "";
    console.log("partyplace", partyplaceResult)
    if (lastRecord?.created_date_time) {
      try {
        const dt = new Date(lastRecord.created_date_time.trim());
        if (!isNaN(dt)) {
          createdISO = dt.toISOString();
        }
      } catch { }
    }
    if (lastRecord?.lrDate) {
      try {
        const [d, m, y] = lastRecord.lrDate.split("/");
        const lrDt = new Date(+y, +m - 1, +d);
        if (!isNaN(lrDt)) {
          lrISO = lrDt.toISOString().replace(/\.\d{3}.*$/, ".000Z");
        }
      } catch { }
    }
    console.log("patyplace", partyplaceResult)
    const selectedRemarks = Object.keys(selectedRemarkCheckboxes).filter(k => selectedRemarkCheckboxes[k]);
    const finalPayload = {
      ...alkemPayload,
      fgrn_date: createdISO || "",
      grn_date: createdISO || "",
      entryDate: createdISO || "",
      lr_date: lrISO || "",
      fromDate: moment(fromDate).format("YYYY-MM-DD"),
      endDate: moment(toDate).format("YYYY-MM-DD"),
      remark: alkemPayload.remarks || "",
      partyPlace: partyplaceResult,
      selectedRemarks: selectedRemarks.length > 0 ? selectedRemarks : null,
    };
    setLoading(true);
    try {
      const serverBase = getDecryptedSessionItem("server");
      const apiUrl = `${serverBase}/send-fgrn`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(finalPayload),
      });
      const result = await response.json();
      if (response.ok && result.status === "success") {
        const fgrnNo = result?.alkem_response?.data[0]?.fgrnNo;
        const alkem_response_messege = result?.alkem_response?.data[0]?.message || "";

        toast.success(
          `Successfully sent to Alkem (${result.total_products || filtered.length} products)`
        );

        Swal.fire({
          icon: "success",
          title: "Sent to Alkem Successfully",
          html: `
      <p><strong>Products Sent:</strong> ${result.total_products || filtered.length}</p>
      <p><strong>FGRN No:</strong> ${fgrnNo || "Not Available"}</p>
      <p><strong>Message:</strong> ${alkem_response_messege}</p>
    `,
          confirmButtonColor: "#3085d6",
        });

        setOpenAlkemSendModal(false);
      } else {
        toast.error(result.error || "Failed to send data to Alkem");

        // Swal.fire({
        //   icon: "error",
        //   title: "Failed to Send",
        //   text: result.error || "Failed to send data to Alkem",
        //   confirmButtonColor: "#d33",
        // });
      }
    } catch (err) {
      console.error("Send to Alkem error:", err);
      toast.error("Network error while sending to Alkem");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (records.length === 0) return;

    const lastRecord = records[records.length - 1];

    if (!lastRecord?.created_date_time || !lastRecord?.lrDate) return;
    let createdISO = "";
    try {
      const dt = new Date(lastRecord.created_date_time.trim());
      if (!isNaN(dt.getTime())) {
        createdISO = dt.toISOString();

      }
    } catch (e) {
      console.warn("Invalid created_date_time format", lastRecord.created_date_time);
    }
    let lrISO = "";
    try {
      const [dd, mm, yyyy] = lastRecord.lrDate.trim().split("/");
      if (dd && mm && yyyy) {
        const lrDt = new Date(Number(yyyy), Number(mm) - 1, Number(dd), 0, 0, 0);
        if (!isNaN(lrDt.getTime())) {
          lrISO = lrDt.toISOString().replace(/\.\d{3}.*$/, ".000Z");
        }
      }
    } catch (e) {
      console.warn("Invalid lrDate format", lastRecord.lrDate);
    }
    setAlkemPayload(prev => ({
      ...prev,
      fgrn_date: createdISO || prev.fgrn_date,
      grn_date: createdISO || prev.grn_date,
      entryDate: createdISO || prev.entryDate,
      lr_date: lrISO || prev.lr_date,
      partyPlace: lastRecord?.region || prev.partyPlace,
    }));
  }, [records]);
  return (
    <div>
      <Typography
        variant="h5"
        style={{ textAlign: "center", marginBottom: 20 }}
      >
        Download Report
      </Typography>
      <div className="container">
        {loading && (
          <LoadingScreen
            loading={loading}
            message={"Loading report, please wait.."}
          />
        )}
        <div className="row">
          <div className="col">
            <div className="mb-3">
              <label htmlFor="">From Date</label>
              <input
                type="date"
                defaultValue={moment().format("YYYY-MM-DD")}
                onChange={(e) => {
                  setFromDate(
                    moment(e.target.value, "YYYY-MM-DD")
                      .startOf("day")
                      .format("YYYY-MM-DD HH:mm:ss")
                  );
                }}
                className="form-control"
              />
            </div>
          </div>
          <div className="col">
            <div className="mb-3">
              <label htmlFor="">To Date</label>
              <input
                type="date"
                defaultValue={moment().format("YYYY-MM-DD")}
                onChange={(e) => {
                  setToDate(
                    moment(e.target.value, "YYYY-MM-DD")
                      .endOf("day")
                      .format("YYYY-MM-DD HH:mm:ss")
                  );
                }}
                className="form-control"
              />
            </div>
          </div>
          <div className="col d-flex align-items-end pb-3">
            <button className="btn btn-success" onClick={loadTodaysReport}>
              Create Report
            </button>
          </div>
        </div>
        {loading && <div>Loading report, please wait..</div>}
        {!loading && stockists.length !== 0 && (
          <p className="font-weight-bold">Report data available</p>
        )}
        {!loading && stockists.length === 0 && (
          <p className="font-weight-bold text-danger">
            Report data not yet available
          </p>
        )}
      </div>
      <hr />
      {stockists.length > 0 && (
        <div
          style={{
            display: "flex",
            marginTop: -10,
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              marginTop: -10,
            }}
          >
            <text
              style={{
                margin: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              Category :
            </text>
            {Object.keys(selectedCategoryCheckboxes).map((category) => (
              <div
                key={category}
                style={{
                  margin: "10px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Checkbox
                  checked={selectedCategoryCheckboxes[category]}
                  onChange={() => handleCategoryCheckboxChange(category)}
                />
                <Typography style={{ marginLeft: "5px" }}>
                  {category}
                </Typography>
              </div>
            ))}
          </div>
          <div
            style={{
              margin: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              width: 600,
            }}
          >
            <div>
              <span className="input-group-text" id="basic-addon1">
                Stockist
              </span>
            </div>
            <select
              className="form-control"
              style={{ marginLeft: "10px" }}
              onChange={(e) => {
                onSelectStockist(e.target.value);
              }}
            >
              {stockists.map((item) => {
                return (
                  <option value={item.clientCode}>{item.clientName}</option>
                );
              })}
            </select>
            {records.length > 0 &&
              Object.values(selectedCategoryCheckboxes).some(Boolean) ? (
              <button
                className="btn btn-primary float-end"
                style={{ marginLeft: "10px" }}
                onClick={() =>
                  handleDownloadSelectedCategories(
                    selectedCategoryCheckboxes,
                    selectedRemarkCheckboxes
                  )
                }
              >
                Download
              </button>
            ) : Object.values(selectedRemarkCheckboxes).some(Boolean) ? (
              <button
                className="btn btn-primary float-end"
                style={{ marginLeft: "10px" }}
                onClick={() =>
                  handleDownloadSelectedRemark(
                    selectedCategoryCheckboxes,
                    selectedRemarkCheckboxes
                  )
                }
              >
                Download
              </button>
            ) : (
              <CSVLink
                headers={headers}
                data={
                  getDecryptedSessionItem("reportType") === "mkparekh"
                    ? mkParekhData
                    : updatedRecordsData
                }
                filename={fileName}
                className="btn btn-primary float-end"
                style={{ marginLeft: "10px" }}
              >
                Download
              </CSVLink>
            )}
            {getDecryptedSessionItem("reportType") === "zydus" && (
              <button
                className="btn btn-primary float-end"
                style={{ marginLeft: "10px" }}
                onClick={handleDownloadNovasFile}
              >
                Novas file
              </button>
            )}
            {getDecryptedSessionItem("reportType") === "alkem" && (
              <button
                className="btn btn-success float-end"
                style={{ marginLeft: "10px" }}
                onClick={() => {
                  setAlkemPayload(prev => ({
                    ...prev,
                    fromDate: moment(fromDate).format("YYYY-MM-DD"),
                    endDate: moment(toDate).format("YYYY-MM-DD"),
                  }));
                  setOpenAlkemSendModal(true);
                }}
                disabled={loading || records.length === 0}
              >
                Send to Alkem
              </button>
            )}
            {getDecryptedSessionItem("reportType") === "alembic" ? (
              <button
                style={{ width: 300, marginLeft: 10 }}
                className="btn btn-primary float-end "
                onClick={handleDownload}
              >
                Download TXT
              </button>
            ) : (
              ""
            )}
            {getDecryptedSessionItem("reportType") === "sun" ? (
              <>
                {records.length > 0 &&
                  Object.values(selectedCategoryCheckboxes).some(Boolean) ? (
                  <button
                    style={{ width: 300, marginLeft: 10 }}
                    className="btn btn-primary float-end "
                    onClick={() =>
                      handleDownloadSelectedCategoriesText(
                        selectedCategoryCheckboxes,
                        selectedRemarkCheckboxes
                      )
                    }
                  >
                    With Name
                  </button>
                ) : Object.values(selectedRemarkCheckboxes).some(Boolean) ? (
                  <button
                    style={{ width: 300, marginLeft: 10 }}
                    className="btn btn-primary float-end "
                    onClick={() =>
                      handleDownloadSelectedRemarkText(
                        selectedCategoryCheckboxes,
                        selectedRemarkCheckboxes
                      )
                    }
                  >
                    With Name
                  </button>
                ) : (
                  <button
                    style={{ width: 300, marginLeft: 10 }}
                    className="btn btn-primary float-end "
                    onClick={handleDownload}
                  >
                    With Name
                  </button>
                )}
              </>
            ) : (
              ""
            )}
          </div>
        </div>
      )}
      {getDecryptedSessionItem("reportType") === "mkparekh" ? (
        <>
          {" "}
          {stockists.length > 0 && (
            <div
              style={{
                display: "flex",
                marginTop: -10,
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  marginTop: -10,
                }}
              >
                <text
                  style={{
                    margin: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Remark :
                </text>
                {Object.keys(selectedRemarkCheckboxes).map((category) => (
                  <div
                    key={category}
                    style={{
                      margin: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Checkbox
                      checked={selectedRemarkCheckboxes[category]}
                      onChange={() => handleRemarkCheckboxChange(category)}
                    />
                    <Typography style={{ marginLeft: "5px" }}>
                      {category}
                    </Typography>
                    {editRemark.category === category ? (
                      <>
                        <input
                          type="text"
                          className="form-control form-control-md"
                          value={editRemark.value}
                          onChange={handleEditChange}
                          style={{ marginLeft: "10px", width: "100px" }}
                        />
                        <button
                          className="btn btn-sm btn-success"
                          onClick={() => handleEditSubmit(category)}
                          style={{ marginLeft: "5px" }}
                        >
                          Save
                        </button>
                      </>
                    ) : (
                      <button
                        className="btn btn-sm btn-success"
                        onClick={() => {
                          setEditRemark({ category, value: category });
                        }}
                        style={{ marginLeft: "10px" }}
                      >
                        Edit
                      </button>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          {" "}
          {stockists.length > 0 && (
            <div
              style={{
                display: "flex",
                marginTop: -10,
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  marginTop: -10,
                }}
              >
                <text
                  style={{
                    margin: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Remark :
                </text>
                {Object.keys(selectedRemarkCheckboxes).map((category) => (
                  <div
                    key={category}
                    style={{
                      margin: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Checkbox
                      checked={selectedRemarkCheckboxes[category]}
                      onChange={() => handleRemarkCheckboxChange(category)}
                    />
                    <Typography style={{ marginLeft: "5px" }}>
                      {category}
                    </Typography>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
      <Divider />
      {records.length > 0 && stockists.length > 0 && (
        <table className="table table-striped" style={{ minWidth: 1000 }}>
          <thead>
            <tr>
              <th>#</th>
              <th>Type</th>
              <th>Product Name</th>
              <th>Batch Number</th>
              <th>MRP</th>
              <th>Quantity</th>
              <th>Expiry Date</th>
              <th>Mfg Date</th>
              <th>Category</th>
              <th>Remark</th>
              {getDecryptedSessionItem("reportType") === "mkparekh" ? (
                <>
                  {" "}
                  <th>Edit</th>
                </>
              ) : (
                ""
              )}
            </tr>
          </thead>
          <tbody>
            {[...records]
              .filter((item) => {
                if (getDecryptedSessionItem("reportType") === "alembic") {
                  const anyRemarkSelected = Object.values(selectedRemarkCheckboxes || {}).some(Boolean);
                  if (anyRemarkSelected) {
                    const remark = item?.remark || "Uncategorized";
                    return selectedRemarkCheckboxes?.[remark];
                  }
                }
                return true;
              })
              .sort((a, b) => {
                const reportType = getDecryptedSessionItem("reportType");
                if (reportType === "alembic") {
                  if (a.category < b.category) return -1;
                  if (a.category > b.category) return 1;
                  if (a.sku < b.sku) return -1;
                  if (a.sku > b.sku) return 1;
                  return 0;
                } else {
                  if (a.sku < b.sku) return -1;
                  if (a.sku > b.sku) return 1;
                  return 0;
                }
              })
              .map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.type}</td>
                    {/* <td>{item["associatedWith"]}</td> */}
                    <td>{item?.sku}</td>
                    <td>{
                      getDecryptedSessionItem("reportType")?.toLowerCase() === "zydus"
                        ? item?.obatch
                          ? item?.obatch
                          : item?.batch
                        : item?.batch
                    }</td>
                    <td>{parseFloat(item?.mrp)}</td>
                    {getDecryptedSessionItem("reportType") === "mkparekh" ? (
                      <>
                        {" "}
                        <td>
                          {" "}
                          <input
                            type="number"
                            value={quantities[index]}
                            className="form-control form-control-md"
                            onChange={(e) =>
                              handleQuantityChange(
                                index,
                                e.target.value,
                                item?.id
                              )
                            }
                          />
                        </td>
                      </>
                    ) : (
                      <td>{item?.quantity}</td>
                    )}

                    <td>
                      {moment(item["expiry"], "MM-YYYY")
                        .endOf("month")
                        .format("DD/MM/YYYY")}
                    </td>
                    <td>
                      {item["mfg"] === "nan" ||
                        item["mfg"] === "Invalid date" ||
                        item["mfg"] === "" ||
                        item["mfg"] === "-NA-"
                        ? ""
                        : moment(item["mfg"], "MM-YYYY")
                          .endOf("month")
                          .format("DD/MM/YYYY")}
                    </td>
                    <td>{item?.category}</td>
                    <td>{item?.remark}</td>
                    {/* <td>{item["verified"] ? "Yes" : "No"}</td> */}
                    {getDecryptedSessionItem("reportType") === "mkparekh" ? (
                      <>
                        <td>
                          <button
                            className="btn btn-sm btn-success"
                            onClick={() => {
                              handleQuantitySubmit(
                                item?.id,
                                index,
                                item?.clientCode
                              );
                            }}
                          >
                            Edit
                          </button>
                        </td>
                      </>
                    ) : (
                      ""
                    )}
                  </tr>
                );
              })}
          </tbody>
        </table>
      )}
      <Modal
        open={openAlkemSendModal}
        onClose={() => setOpenAlkemSendModal(false)}
        aria-labelledby="alkem-send-modal-title"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: 600, md: 800 },
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            maxHeight: '90vh',
            overflowY: 'auto',
          }}
        >
          {(() => {
            const filteredRecords = getFilteredRecordsForAlkem();
            const productCount = filteredRecords.length;
            return (
              <>
                <Typography id="alkem-send-modal-title" variant="h5" component="h2" gutterBottom>
                  Send FG Return Note to Alkem
                </Typography>
                <Typography variant="body1" color="text.secondary" paragraph>
                  This will send the current filtered report data ({productCount} products) to Alkem.
                  {productCount !== records.length && (
                    <span> (out of {records.length} total)</span>
                  )}.
                </Typography>
              </>
            );
          })()}
          <Divider sx={{ my: 2 }} />
          <Typography variant="subtitle1" gutterBottom>
            Period: {moment(fromDate).format("DD-MM-YYYY")} – {moment(toDate).format("DD-MM-YYYY")}
          </Typography>
          <Box sx={{ mb: 3 }}>
            <Typography variant="subtitle2" color="primary">
              Selected Party / Stockist
            </Typography>
            <Typography>
              <strong>Party Name:</strong> {alkemPayload.partyName || "— not selected —"}
            </Typography>
            <Typography>
              <strong>Party Code:</strong> {alkemPayload.partyCode || "— not selected —"}
            </Typography>
          </Box>
          <Divider sx={{ my: 2 }} />
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            Full Payload Preview (what will be sent)
          </Typography>
          <Box
            component="pre"
            sx={{
              backgroundColor: '#f5f5f5',
              p: 2,
              borderRadius: 1,
              fontSize: '0.85rem',
              overflowX: 'auto',
              maxHeight: '300px',
              border: '1px solid #ddd',
            }}
          >
            {JSON.stringify(alkemPayload, null, 2)}
          </Box>
          <Divider sx={{ my: 3 }} />
          <Grid container spacing={2}>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Remarks"
                  value={alkemPayload.remarks || ""}
                  onChange={(e) => setAlkemPayload(prev => ({ ...prev, remarks: e.target.value }))}
                  fullWidth
                  multiline
                  rows={2}
                  size="small"
                  margin="dense"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Number of Cases"
                  type="number"
                  value={alkemPayload.no_of_cases}
                  onChange={(e) => setAlkemPayload(prev => ({ ...prev, no_of_cases: Number(e.target.value) || 0 }))}
                  fullWidth
                  size="small"
                  margin="dense"
                  inputProps={{ min: 0 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Transport Name"
                  value={alkemPayload.transportName || ""}
                  onChange={(e) => setAlkemPayload(prev => ({ ...prev, transportName: e.target.value }))}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="LR Number"
                  value={alkemPayload.lr_num || ""}
                  onChange={(e) => setAlkemPayload(prev => ({ ...prev, lr_num: e.target.value }))}
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Vendor Reference No"
                  value={alkemPayload.vendorRefNo || ""}
                  onChange={(e) => setAlkemPayload(prev => ({ ...prev, vendorRefNo: e.target.value.trim() }))}
                  fullWidth
                  size="small"
                  placeholder="e.g. VEND-REF-456"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="DC File / Document"
                  value={alkemPayload.dcFile || ""}
                  onChange={(e) => setAlkemPayload(prev => ({ ...prev, dcFile: e.target.value.trim() }))}
                  fullWidth
                  size="small"
                  placeholder="DC number or file reference"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Reference Invoice (refInv)"
                  value={alkemPayload.refInv || ""}
                  onChange={(e) => setAlkemPayload(prev => ({ ...prev, refInv: e.target.value.trim() }))}
                  fullWidth
                  size="small"
                  placeholder="e.g. INV/2025/1234"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Party Reference No"
                  value={alkemPayload.party_ref || ""}
                  onChange={(e) => setAlkemPayload(prev => ({ ...prev, party_ref: e.target.value.trim() }))}
                  fullWidth
                  size="small"
                  placeholder="Party's own reference number"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Party Reference Date"
                  type="date"
                  value={alkemPayload.party_ref_date ? moment(alkemPayload.party_ref_date).format("YYYY-MM-DD") : ""}
                  onChange={(e) => setAlkemPayload(prev => ({
                    ...prev,
                    party_ref_date: e.target.value ? moment(e.target.value).toISOString() : ""
                  }))}
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Divider sx={{ my: 3 }} />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
            <Button
              variant="outlined"
              onClick={() => setOpenAlkemSendModal(false)}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSendToAlkem}
              disabled={loading || !alkemPayload.partyCode || !alkemPayload.partyName}
            >
              {loading ? (
                <>
                  <CircularProgress size={20} sx={{ mr: 1 }} />
                  Sending...
                </>
              ) : (
                "Confirm & Send to Alkem"
              )}
            </Button>
          </Box>
          {(!alkemPayload.partyCode || !alkemPayload.partyName) && (
            <Alert severity="warning" sx={{ mt: 2 }}>
              Party Code or Party Name is missing. Please select a stockist first.
            </Alert>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default ExportReports;
